import React from 'react';
import { Box, Button } from '@mui/material';

interface PlaceTabsProps {
  /**
   * Index of the currently selected tab
   */
  value: number;
  /**
   * Callback fired when the tab is changed
   */
  onChange: (newValue: number) => void;
}

const tabs = ['Description', 'Posts', 'Shorts'];

const PlaceTabs: React.FC<PlaceTabsProps> = ({ value, onChange }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        // backgroundColor: '#eee6e1',
        borderRadius: 5,
        overflow: 'hidden',
        my: 2,
        gap: 0.5,
      }}
    >
      {tabs.map((label, index) => {
        const isSelected = value === index;
        const isFirst = index === 0;
        const isLast = index === tabs.length - 1;
        
        // Determine radius based on selection state and position
        let borderRadius: number | string = 0;
        if (isSelected) {
          // Selected tab gets radius on both sides
          borderRadius = '24px';
        } else {
          // Non-selected tabs get radius only on their respective sides
          if (isFirst) {
            borderRadius = '40px 6px 6px 40px';
          } else if (isLast) {
            borderRadius = '6px 40px 40px 6px';
          }
          else {
            borderRadius = '6px';
          }
        }

        return (
          <Button
            key={label}
            onClick={() => onChange(index)}
            sx={{
              flex: 1,
              textTransform: 'none',
              fontWeight: 600,
              color: isSelected ? 'white' : 'text.primary',
              backgroundColor: isSelected ? '#ff6b35' : '#ECE0DA',
              '&:hover': {
                backgroundColor: isSelected ? '#e55a2b' : '#f3ece7',
              },
              borderRadius: borderRadius,
              py: 1.5,
              // Add white divider between tabs (except for the last tab)
              ...(index < tabs.length - 1 && {
                borderRight: '1px solid white',
              }),
            }}
          >
            {label}
          </Button>
        );
      })}
    </Box>
  );
};

export default PlaceTabs; 